module.exports = __webpack_public_path__ + "img/box-uni.a27b2469.png";